module.exports = __webpack_public_path__ + "img/1724248811831-IMG_1532.png.0eb90721.webp";